(function () {
  'use strict';

  var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');

  var setCharacterLimit = function (editor, num) {
    if (num === null) {
      editor.options.unset('character_limit');
    } else {
      editor.options.set('character_limit', num);
    }

    updateCount(editor);
  }

  var countCharacters = function (editor) {
    var text = editor.plugins.content.getText();
    return text.replace(/\n\n/g, " ").length;
  };

  var exceedsCharacterLimit = function (editor) {
    var limit = editor.options.get('character_limit') || null;
    if (limit === null) {
      return false;
    }

    return countCharacters(editor) > limit;
  }

  var get = function (editor) {
    return {
      getCharacterCount: () => countCharacters(editor),
      setCharacterLimit: (num) => setCharacterLimit(editor, num),
      exceedsCharacterLimit: () => exceedsCharacterLimit(editor),
    };
  };

  var global = tinymce.util.Tools.resolve('tinymce.util.Delay');

  var debounce = function (callback, time) {
    let interval;
    return function () {
      clearTimeout(interval);
      interval = setTimeout(function (){
        interval = null;
        callback(arguments);
      }, time);
    };
  }

  var updateCount = function (editor) {
    $(editor.getContainer())
        .find('.tox-statusbar__limiter')
        .toggle((editor.options.get('character_limit') || null) !== null);

    $(editor.getContainer())
      .find('.tox-statusbar__limiter-count')
      .text(countCharacters(editor));

    $(editor.getContainer())
        .find('.tox-statusbar__limiter-limit')
        .text(editor.options.get('character_limit'));
  };

  var register = function (editor) {
    const registerOption = editor.options.register;
    registerOption("character_limit", { processor: "number" });
  };

  var setup = function (editor, api, delay) {
    var debouncedUpdate = debounce(function () {
      return updateCount(editor);
    }, delay);

    editor.on('init', function () {
      global.setEditorTimeout(editor, function () {
        editor.on('SetContent BeforeAddUndo Undo Redo ViewUpdate keyup', debouncedUpdate);
      }, 0);

      $(editor.getContainer())
        .find('.tox-statusbar')
        .append(
          '<div class="tox-statusbar__limiter">' +
            '<span class="tox-statusbar__limiter-count">0</span> / ' +
            '<span class="tox-statusbar__limiter-limit">0</span> characters' +
          '</div>'
        );

      updateCount(editor);
    });
  };

  function Plugin (delay) {
    if (delay === void 0) {
      delay = 300;
    }
    global$1.add('limiter', function (editor) {
      var api = get(editor);
      register(editor);
      setup(editor, api, delay);
      return api;
    });
  }

  Plugin();

}());
